import {createFeature, createReducer, on} from "@ngrx/store";
import {APP_CONSTANTS} from "../../app.constants";
import {CountryInterface, FilterInterface} from "../../interfaces";
import * as CountryActions from "../actions/countries.actions";

export const countryFeatureKey = "Countries";

export interface State {
  countryItems: Array<CountryInterface>;
  countryFilters: FilterInterface;
}

export const initialState: State = {
  countryItems: [],
  countryFilters: {
    limit: APP_CONSTANTS.PAGINATION_PAGE_SIZE,
    offset: 0
  }
};

export const countryFeature = createFeature({
  name: countryFeatureKey,
  reducer: createReducer(
    initialState,
    on(CountryActions.setCountries, (state: State, {countries}): State => ({
      ...state,
      countryItems: countries
    }))
  )
});

export const {
  name,
  reducer,
  selectCountryItems
} = countryFeature;
